import { Form, Select } from "antd";

const { Option } = Select;

export const DigitsSelect = ({ formItemName, disabled, placeholder, style }) => {
    return (
        <>
            <Form.Item
                name={formItemName}
                rules={[{ required: !disabled, message: 'Insira o número do slave' }]}
                noStyle
            >
                <Select disabled={disabled} placeholder={placeholder} style={style}>
                    <Option value={1}>{1}</Option>
                    <Option value={2}>{2}</Option>
                    <Option value={3}>{3}</Option>
                    <Option value={4}>{4}</Option>
                    <Option value={5}>{5}</Option>
                    <Option value={6}>{6}</Option>
                    <Option value={7}>{7}</Option>
                    <Option value={8}>{8}</Option>
                    <Option value={9}>{9}</Option>
                </Select>
            </Form.Item>
        </>
    );
}